import type { TaskDetailSectionRequest } from "./TaskDetail/constants";
import type { TasksContextValue } from "./tasks.context";

const SECTION_DELAY_MS = 10;

/**
 * Shows a section of the task just selected (its chat, Dependencies or
 * Details) in the expanded right pane, a beat later so the pane for that
 * task is there. Chat becomes the pane's content. Any other section goes
 * through `requestTaskDetailSection`: the redesigned view selects its tab,
 * and the legacy view leaves the content alone and opens and scrolls to the
 * section's accordion item in `taskId`'s sidebar. List's chat button, the
 * board's chips and Edit details open sections this way.
 */
export const showTaskSection = ({
    taskDetailPanelRef,
    setTaskDetailPanelContent,
    requestTaskDetailSection,
    section,
    taskId,
}: Pick<
    TasksContextValue,
    | "taskDetailPanelRef"
    | "setTaskDetailPanelContent"
    | "requestTaskDetailSection"
> & { section: "chat" | TaskDetailSectionRequest; taskId: string }) => {
    setTimeout(() => {
        taskDetailPanelRef.current?.expand();
        if (section === "chat") {
            setTaskDetailPanelContent("chat");
            return;
        }
        requestTaskDetailSection({ section, taskId });
    }, SECTION_DELAY_MS);
};
